import React from 'react';

function ModalUpsellCalculatePercentSale({ price, comparePrice }) {
  if (!(comparePrice > 0 && price > 0 && comparePrice > price)) {
    return <></>;
  }

  const discount = 100 - Math.round((price / comparePrice) * 100);
  return (
    <span className="modal-upsell__badge-sale">
      {discount}% Off
    </span>
  );
}



export default ModalUpsellCalculatePercentSale;